var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletIconGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6562 3.07297H16.927V2.34375C16.927 1.05133 15.8757 0 14.5833 0H2.31766C1.03973 0 0 1.03973 0 2.31766V17.5391C0 18.896 1.10397 20 2.46094 20H17.6562C18.9487 20 20 18.9487 20 17.6562V5.41672C20 4.1243 18.9487 3.07297 17.6562 3.07297ZM18.4375 13.0598H15.3777C14.5375 13.0598 13.8542 12.3766 13.8542 11.5364C13.8542 10.6964 14.5375 10.013 15.3777 10.013H18.4375V13.0598ZM2.31766 1.5625H14.5833C15.014 1.5625 15.3645 1.91299 15.3645 2.34375V3.07297H2.31766C1.90125 3.07297 1.5625 2.73407 1.5625 2.31766C1.5625 1.90125 1.90125 1.5625 2.31766 1.5625ZM17.6562 18.4375H2.46094C1.96548 18.4375 1.5625 18.0345 1.5625 17.5391V4.50912C1.79932 4.59091 2.05338 4.63531 2.31766 4.63531H17.6562C18.087 4.63531 18.4375 4.98581 18.4375 5.41656V8.45047H15.3777C13.676 8.45047 12.2917 9.8349 12.2917 11.5364C12.2917 13.2381 13.676 14.6223 15.3777 14.6223H18.4375V17.6562C18.4375 18.087 18.087 18.4375 17.6562 18.4375Z",
    fill: "url(#paint0_linear_2056_10805)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2056_10805",
    x1: 0,
    y1: 10,
    x2: 20,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA80FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIconGradient);
export default __webpack_public_path__ + "static/media/wallet-icon-gradient.46bd9e4ae7efb9cc0779f0d5ecab3f1c.svg";
export { ForwardRef as ReactComponent };